import { environment } from "../../environments/environment";


export enum PlatformTrialMode {
  FREE_TRIAL_WITH_CARD = "FREE_TRIAL_WITH_CARD",
  FREE_TRIAL_WITHOUT_CARD = "FREE_TRIAL_WITHOUT_CARD" // user has this plan for a certain number of days, then needs to upgrade
}

export let FREE_TRIAL_PLATFORM_MODE = PlatformTrialMode.FREE_TRIAL_WITH_CARD;

export const NUMBER_OF_FREE_TRIAL_DAYS = 30;

export function isTrialWithCardActive() {
  return FREE_TRIAL_PLATFORM_MODE == PlatformTrialMode.FREE_TRIAL_WITH_CARD;
}

export function isTrialWithoutCardActive() {
  return FREE_TRIAL_PLATFORM_MODE == PlatformTrialMode.FREE_TRIAL_WITHOUT_CARD;
}

export const EMPTY_IMG =
  "https://d8avu785lzlph.cloudfront.net/images/empty-image.png";

export const CARD_EMPTY_IMG =
  `https://${environment.platformCloudfrontDomain}/assets/images/common/empty-card-img.jpg`;

  // export const CARD_EMPTY_IMG =
//   "https://d8avu785lzlph.cloudfront.net/images/neo-img/empty-file-upload.png";

export const EMPTY_IMG_SQUARE =
  "../../assets/images/common/empty-file-upload.png";

export const DEFAULT_FONT_NAME = "Inter";

export const ONLINECOURSEHOST_PRIMARY_COLOR = "#11294f";

export const ONLINECOURSEHOST_ACCENT_COLOR = "#EB3B3B";

// Default branding for schools — the "Aurora Purple" palette of the redesigned
// course sales page reference design: purple chrome + purple accent (the
// reference mockup's nav uses the same purple as the accent).
// Platform-site branding (ONLINECOURSEHOST_*) intentionally stays separate.
export const DEFAULT_SCHOOL_PRIMARY_COLOR = "#6D4DC8";

export const DEFAULT_SCHOOL_ACCENT_COLOR = "#6D4DC8";

export const DEFAULT_SCHOOL_SALES_BANNER_COLOR = "#2B2547";

export const DEFAULT_SCHOOL_FOOTER_COLOR = "#221C3A";

// Revamped header/footer default accent — lighter than DEFAULT_SCHOOL_ACCENT_COLOR for contrast on the dark nav.
export const DEFAULT_NAV_ACCENT_COLOR = "#9F7CFF";

export const BLANK_FIELD_REGEX = /\[\s*\]/g;

export const isHexColorRegex = /^#[0-9A-F]{6}$/i;
